export const TranslationIdMap = '';

export const TranslationKeyMap = {
    '_9549_OPPORTUNITY_COACHING': 'Opportunity Coaching',
    '_9550_NON_OPPORTUNITY_KPI_GOAL_COACHING': 'Non-Opportunity Goal Coaching',
    '_9551_NON_KPI_GOAL_COACHING': 'Non-KPI Goal Coaching',
    '_7488_COACHED': 'Coached',
    '_7489_UNCOACHED': 'Uncoached',
    '_7508_MISSED_OPPORTUNITIES': 'Missed Opportunities',
    '_842_N_A': 'N/A',
    '_9525_B_': 'B:',
    '_9526_S_B_': 'Tactic:',
    '_9476_DRAFT': 'Draft',
    '_9495_PRE_APPROVAL': 'Pre-Approval',
    '_125_ACTIVE': 'Active',
    '_7441_PENDING_CLOSE': 'Pending Close',
    '_7440_CLOSED': 'Closed',
    '_9552_SG_': 'SG:',
    '_9553_MANAGER_': 'Manager:',
    '_8702_UPDATING': 'Updating'
};
